import React from 'react';
import { motion } from 'framer-motion';
import Card from '../components/common/Card';
import Footer from '../components/common/Footer';

const Privacy: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gray-50 py-8"
    >
      <div className="max-w-4xl mx-auto px-4">
      <Card className="p-8">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-4">Privacy Policy</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">Effective Date: May 11, 2025</p>
        
        <div className="prose dark:prose-invert max-w-none">
          <p className="lead">
            VoiceVision ("we", "us", or "our") respects your privacy and is committed to protecting your personal information.
            This Privacy Policy explains how we collect, use, and protect information through our website and web app.
          </p>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
          <ul>
            <li><strong>Account Info</strong>: Email address, name (optional), and authentication data.</li>
            <li><strong>Usage Data</strong>: Session durations, subscription plan, and feature usage.</li>
            <li><strong>API Keys</strong>: If you choose to input your OpenAI API key, it is encrypted and only used to run your sessions.</li>
            <li><strong>Cookies</strong>: Used for session tracking and dark/light mode preferences.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">2. How We Use Your Data</h2>
          <ul>
            <li>To provide and maintain your access to the app</li>
            <li>To process your subscriptions and payments (via Stripe)</li>
            <li>To track your session usage and offer personalized experiences</li>
            <li>To improve VoiceVision's performance and support</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">3. Data Protection</h2>
          <ul>
            <li>Your data is encrypted at rest and in transit.</li>
            <li>API keys are stored securely and not shared.</li>
            <li>We do not sell your personal data.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">4. Third-Party Services</h2>
          <p>
            We use Stripe for payments and OpenAI for session functionality. These services may collect
            information as governed by their respective privacy policies.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">5. Your Rights</h2>
          <ul>
            <li>You may request access, update, or deletion of your personal data.</li>
            <li>Contact us at support@voicevision.app for any privacy-related inquiries.</li>
          </ul>
        </div>
      </Card>
      
      <Footer />
      </div>
    </motion.div>
  );
};

export default Privacy;